module.exports = __webpack_public_path__ + "media/stylesheets/images/folk_logo-964a1cdc3c3a2d84ae60c9e18c5aed7a.svg";